import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class Areas extends React.Component {
    renderArea(area, index) {
        const isActive = _.isEqual(this.props.activeArea, area);
        const isDisabled = this.props.disabledAreas.includes(area);
        const classes = ['menu__item'];
        let key = `printable-area-${index}`;
        let onClick = () => this.props.onAreaSelect(area);

        if (isDisabled) {
            classes.push('menu__item--disabled');
            onClick = null;
        }

        if (isActive) {
            classes.push('menu__item--active');
        }

        return (
            <li className={classes.join(' ')} key={key} onClick={onClick}>
                {/*<span className="label">{`Druckfläche ${index + 1}`}</span>*/}
                <span className="label">{area}</span>
            </li>
        );
    }
    render() {
        const { areas } = this.props;
        return (
            <div className="submenu__row printable-area-selection">
                <ul className="menu">
                    {Object.keys(areas).map((area, index) => this.renderArea(area, index))}
                </ul>
            </div>
        );
    }
}

Areas.propTypes = {
    disabledAreas: PropTypes.array,
};

Areas.defaultProps = {
    disabledAreas: [],
};

export default Areas;
